import { Trip, Editor } from './../classes.js';

export function trip_block__element(data, edit = false){
	let $content = '';
	let $edit = '';
	let $header = '';
	let $title = '';
	
	$content = $('<section/>', {
		'class': (edit) ? `trip__block ${Trip.view == 'publish' ? 'trip__block--publish' : 'trip__block--edit'}` : 'trip__block',
		'data-block_id': data.id
	});
	
	if(edit){
		$title = `<span class="trip__block_title">${data.name}</span>`;
		$content.append($title);
	}
	
	if(Trip.has_permission){
		$content.append(`<input class="block_order" type="hidden" name="b[${data.id}][order]" value="${data.order}" />`);
		$content.append(`<input class="block_priority" type="hidden" name="b[${data.id}][priority]" value="${data.priority}" />`);
	}
	
	return $content;
}
